function initCookiesBar() {
	const cookiesBar = document.querySelector("#notice-cookie-block");
	if (cookiesBar) {
		if (!Cookies.get('cookies-bar')) {
			document.querySelector("#notice-cookie-block").classList.add("visible");
			document.body.classList.add("cookies-bar-visible");
			document.querySelector("#notice-cookie-block button").addEventListener("click", () => {
				Cookies.set('cookies-bar', true, {
					expires: 30
				});
				document.querySelector("#notice-cookie-block").classList.remove("visible");
				document.body.classList.remove("cookies-bar-visible");
			});
		}
	}
}
initCookiesBar();